export const LOADING_STATE = {
    PRE: -1,
    LOADED: 0
};
